import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const ContanerDiv = styled.div`
  height: 100%;
  width: 100%;
`;
const CenterContanerDiv = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Loading = props => {
	const { className, fontSize = 60, children, spinning } = props;
	const indicator = <LoadingOutlined style={{ fontSize }} />;
	const Contaner = children ? ContanerDiv : CenterContanerDiv;

	return (
		<Contaner className={className}>
			<Spin indicator={indicator} spinning={spinning}>
				{children}
			</Spin>
		</Contaner>
	);
};

export default Loading;
